import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    success: false,
    data: {
        jasperUrl: '',
    },
    isJasperLoading: true,
    jasperSelectedClasses: '',
};

const jasperSlice = createSlice({
    name: 'jasper',
    initialState,
    reducers: {
        setJasperData: (state, action) => {
            state.success = action.payload.success;
            state.data.jasperUrl = action.payload.data.jasperUrl;
        },
        setIsJasperLoading: (state, action) => {
            state.isJasperLoading = action.payload;
        },
        setJasperSelectedClass: (state, action) => {
            state.jasperSelectedClasses = action.payload;
        },
    },
});

export const { setJasperData, setIsJasperLoading, setJasperSelectedClass } =
    jasperSlice.actions;

export default jasperSlice.reducer;
